import { PickupDashboardMapper } from "@/data/persistences/mappers/PickupDashboardMapper";
import { PickupDashboardRepositoryInterface } from "@/data/persistences/repositories/contracts/PickupDashboardRepositoryInterface";
import { PickupDashboardEndpoint } from "@/app/infrastructures/endpoints/PickupDashboardEndpoint";
import ApiService from "@/app/infrastructures/services/ApiService";
import { ApiRequestList } from "@/domain/entities/MainApp";
// import { RequestTabsList, TabsList } from "@/domain/entities/PickupDashboardSummary";
import { RequestListSummary, RequestTabsList, TabsList } from "@/domain/entities/PickupDashboardSummary";
import { CourierSummaryRequest, ShipmentListRequest, PickupShipmentRequest, CourierListRequest, ManualAssignRequest } from "@/data/payload/api/PickupDashboardRequests";
import { CourierPickupSummary, AvailableCourierList, TransferPickupRequest, SenderList, TransferPickupListRequest, CourierPickupShipment, PickupDashboardMonitoringCourierPickupEntities, ManualAssignResponse } from "@/domain/entities/PickupDashboard";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { ExportApiRequest } from "@/data/payload/api/PickupDashboardApiRequest";

export class PickupDashboardApiRepository implements PickupDashboardRepositoryInterface {
  private service: ApiService;
  private mapper: PickupDashboardMapper;
  private endpoints: PickupDashboardEndpoint;

  constructor(
    service: ApiService,
    mapper: PickupDashboardMapper,
    endpoints: PickupDashboardEndpoint
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getTabsList(params: RequestTabsList): Promise<TabsList> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getTabsList(params)
    );
    return this.mapper.convertTabsListFromApi(resp)
  }

  public async getCourierSummary(
    params: CourierSummaryRequest
  ): Promise<CourierPickupSummary> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getCourierSummary(params),
      {}
    );
    return this.mapper.convertCourierSummaryFromApi(resp);
  }

  public async getAvailableCouriers(taskGroupIds?: string, q?: string): Promise<AvailableCourierList> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getAvailableCouriers(taskGroupIds, q)
    );
    return this.mapper.convertAvailableCouriersFromApi(resp);
  }

  public async transferPickup(payload: TransferPickupRequest): Promise<ResponsePayloadV2> {
    const resp = await this.service.invoke(
      "POST",
      this.endpoints.transferPickup(),
      {},
      payload
    );
    return this.mapper.convertTransferPickupFromApi(resp);
  }

  public async export(payload: ExportApiRequest): Promise<ResponsePayloadV2> {
    const resp = await this.service.invoke(
      "POST",
      this.endpoints.export(),
      {},
      payload
    );
    return this.mapper.convertExportFromApi(resp);
  }


  public async getListSummary(payload: RequestListSummary) {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getListSummary(payload)
    )
    return this.mapper.convertListSummaryFromApi(resp)
  }

  public async getShipmentList(
    params: ShipmentListRequest
  ): Promise<ResponsePayloadV2> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getShipmentList(params),
      {}
    );
    return this.mapper.convertShipmentListFromApi(resp);
  }
  
  public async getBookingEligibleShipments(
    params: PickupShipmentRequest
  ): Promise<CourierPickupShipment> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getBookingEligibleShipments(params),
      {}
    );
    return this.mapper.convertCourierShipmentFromApi(resp);
  }

  public async getSenderList(params: TransferPickupListRequest): Promise<SenderList> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getSenderList(params)
    );
    return this.mapper.convertSenderListFromApi(resp);
  }

  public async getCourierList(params: CourierListRequest): Promise<PickupDashboardMonitoringCourierPickupEntities> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getCourierList(params)
    )

    return this.mapper.convertCourierListFromApi(resp);
  }

  public async manualAssign(payload: ManualAssignRequest): Promise<ManualAssignResponse> {
    const resp = await this.service.invoke(
      "POST",
      this.endpoints.manualAssign(),
      {},
      payload
    );
    return this.mapper.convertManualAssignFromApi(resp);
  }
}
